import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { getSailing } from '@go-client/lib/api/itinerary';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';
import { getDayTemplate } from '@go-client/lib/api/template';

export const TemplateFragmentsLog: React.FC<UserActionLog> = ({ body }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        let fields = {};

        if (body.linkFragments) {
          let arrayOfFragments = [];

          for (let fragment of body.linkFragments) {
            let tempFields = { ...fragment };

            const { sailingId, templateId } = fragment;
            if (sailingId) {
              const sailing = await getSailing(sailingId).catch(_error =>
                console.error('Could not get the sailing')
              );

              if (sailing) {
                const sailingFields = FieldsReplacer(sailing, fragment, [
                  {
                    from: 'name',
                    to: 'sailingId',
                  },
                ]);

                const sailingDay = sailing.days.find(d => d._id === fragment.sailingDayId);

                tempFields = {
                  ...tempFields,
                  ...sailingFields,
                };

                if (sailingDay) {
                  const sailingDayFields = FieldsReplacer(sailingDay, fragment, [
                    {
                      from: 'name',
                      to: 'sailingDayId',
                    },
                  ]);

                  tempFields = {
                    ...tempFields,
                    ...sailingDayFields,
                  };
                }
              }
            }

            if (templateId) {
              const dayTemplate = await getDayTemplate(templateId).catch(_error =>
                console.error('Could not get the day template')
              );

              if (dayTemplate) {
                const dayTemplateFields = FieldsReplacer(dayTemplate, fragment, [
                  {
                    from: 'name',
                    to: 'templateId',
                  },
                ]);

                tempFields = {
                  ...tempFields,
                  ...dayTemplateFields,
                };
              }
            }

            arrayOfFragments.push({
              ...tempFields,
            });
          }

          if (arrayOfFragments.length) {
            fields = { ...fields, linkFragments: arrayOfFragments };
          }
        }

        setLogFields({ ...logFields, ...fields });
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
